module.exports = __webpack_public_path__ + "assets/icons/blank-sensor.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/svg/blank-sensor.svg
// module id = CAZ4
// module chunks = 1